import getEditToken from "../../getters/editToken";

const c4DiagramToken = getEditToken("c4-diagram");

export default c4DiagramToken;
